import { render, staticRenderFns } from "./ev6-swiper-xingneng.vue?vue&type=template&id=e4fce604&scoped=true&"
import script from "./ev6-swiper-xingneng.vue?vue&type=script&lang=js&"
export * from "./ev6-swiper-xingneng.vue?vue&type=script&lang=js&"
import style0 from "./ev6-swiper-xingneng.vue?vue&type=style&index=0&id=e4fce604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fce604",
  null
  
)

export default component.exports